import { create } from 'zustand';

export type BackgroundPreset = 
  | 'default' 
  | 'blue' 
  | 'purple' 
  | 'green' 
  | 'red' 
  | 'neutral'
  | { type: 'custom'; from: string; to: string; angle: number };

export type GlobalSettings = {
  showName: string;
  accentColor: string;
  defaultBackground: BackgroundPreset;
  barRadius: number;
  contentPadding: number;
};

const defaultSettings: GlobalSettings = {
  showName: '@Nicefoxnet',
  accentColor: '#ff6b00',
  defaultBackground: 'default',
  barRadius: 8,
  contentPadding: 24,
};

type SettingsState = {
  settings: GlobalSettings;
  updateSettings: (changes: Partial<GlobalSettings>) => void;
};

export const useSettingsStore = create<SettingsState>((set) => ({
  settings: defaultSettings,
  updateSettings: (changes) =>
    set((state) => ({
      settings: { ...state.settings, ...changes },
    })),
}));
